import { StandaloneCoverBox } from '@/base/components/content/CoverBox';
import { convertLinkFormat } from '@/base/components/content/CoverBox/helpers';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { renderContentComponent } from 'modules/dynamic-components';

const LabradorCoverBox: LabradorComponent = ({ type, meta, data, descendants }) => {
  const images = descendants.map(renderContentComponent);

  return (
    <StandaloneCoverBox
      headline={data.title}
      bodyText={convertLinkFormat(data.bodytext || '')}
      images={images}
      options={data.options || {}}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorCoverBox;
